module.exports = __webpack_public_path__ + "media/dance/hiding_under-9e4b3563.mp3";